import { SupportedChainId as ChainId } from "../constants/chains";
import { getNetworkByChainId } from "../functions";
import { TOKEN_SECOND_ADDRESS } from "./addresses";

export const apiTotalStake = (chainId: number) => {
  return "https://api.thegraph.com/subgraphs/name/chinctor/dor-stake-bsc";
};

const url = `https://api.coingecko.com/api/v3/simple/token_price/avalanche?contract_addresses=0x7979871595b80433183950ab6c6457752b585805&vs_currencies=usd`;

export const apiCoinGeckoGetPrice = (chainId: number) => {
  return url;
  return `https://api.coingecko.com/api/v3/simple/token_price/binance-smart-chain?contract_addresses=${TOKEN_SECOND_ADDRESS[getNetworkByChainId(chainId)]
    }&vs_currencies=usd`;
};

export const apiCallWebhook = (webhookUrl: string, payload: any) => {
  return fetch(webhookUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
};
